import React from 'react';

const AccordionItem = ({ title, children, isOpen, onToggle, tag, isLast }) => {
  return (
    <div className={`relative ${isOpen ? 'border-t-2 border-amber' : 'border-none'}`}>
      <button
        onClick={onToggle}
        className="w-full flex items-center justify-between p-4 text-left hover:bg-white/5 transition-colors group border-none outline-none focus:outline-none"
      >
        <div className="flex items-center gap-3">
          <span className={`text-green-400 font-mono text-sm transition-transform duration-200 ${isOpen ? 'rotate-90' : ''}`}>
            ▶
          </span>
          {tag && (
            <span className="text-amber font-mono text-xs">[{tag}]</span>
          )}
          <span className="text-white font-mono font-medium">{title}</span>
        </div>
        <span className="text-white/30 text-xs font-mono group-hover:text-green-400 transition-colors">
          {isOpen ? 'COLLAPSE' : 'EXPAND'}
        </span>
      </button>
      
      <div 
        className={`overflow-hidden transition-all duration-300 ease-in-out border-none ${
          isOpen ? 'max-h-[2000px] opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="px-4 pb-4 pl-12 text-white/70 font-mono text-sm leading-relaxed border-none">
          {children}
        </div>
      </div>
      
      {/* Simple white divider ONLY between closed items (NOT after open items) */}
      {!isLast && !isOpen && (
        <div className="h-px bg-white/10 mx-4" />
      )}
    </div>
  );
};

export const Accordion = ({ items, defaultOpen = [0] }) => {
  const [openItems, setOpenItems] = React.useState(new Set(defaultOpen));

  const toggleItem = (index) => {
    setOpenItems(prev => {
      const newSet = new Set(prev);
      if (newSet.has(index)) {
        newSet.delete(index);
      } else {
        newSet.add(index);
      }
      return newSet;
    });
  };

  return (
    <div className="bg-black/30 border border-white/10 rounded-lg overflow-hidden">
      {items.map((item, index) => (
        <AccordionItem
          key={item.id || index}
          title={item.title}
          tag={item.tag}
          isOpen={openItems.has(index)}
          onToggle={() => toggleItem(index)}
          isLast={index === items.length - 1}
        >
          {typeof item.content === 'string' ? (
            <div dangerouslySetInnerHTML={{ __html: item.content }} />
          ) : (
            item.content
          )}
        </AccordionItem>
      ))}
    </div>
  );
};

export default Accordion;

